import './Cart.css';

import React from 'react';
import { Table, Button, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { addCount, removeCount, removeItem, sortName } from '../component/Store';

const Cart=()=>{
    function total() {
        let sum = 0;
        for (let v in state.cart) {
            sum += state.cart[v].price * state.cart[v].count;
        }
        return sum;
    }
    let state = useSelector((state) => state)  
    let dispatch = useDispatch();
    
    return(
        <div>
            <Container className="cart_wrap">
                <h4>Shopping Cart</h4>
                <Table>                    
                    <tbody>
                        {
                            state.cart.map((v, i) =>
                                <tr key={i}>
                                    <td><img src={state.cart[i].imgUrl} className="image" /></td>
                                    <td>{state.cart[i].name}</td>
                                    <td>{state.cart[i].count}</td>
                                    <td>
                                        <span className="count">
                                            <span onClick={() =>
                                                dispatch(addCount(state.cart[i].id))
                                            } className="amount">UP</span>
                                            <span onClick={() =>
                                                dispatch(removeCount(state.cart[i].id))
                                            } className="amount">DOWN</span>
                                        </span>
                                    </td>
                                    <td>{state.cart[i].price * state.cart[i].count}</td>
                                    <td>
                                        <button onClick={() => {
                                            dispatch(removeItem(state.cart[i].id))
                                        }}>REMOVE</button>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Button variant="outline-dark" onClick={() => {
                    dispatch(sortName(state.cart.Name))
                }} className="button">SORT</Button>{''}
                <Button variant="outline-dark" className="button">CHECKOUT • {total().toLocaleString()}</Button>{''}
            </Container>
        </div>
    )
}

export default Cart;